<template>
  <div class="table-wrapper">
    <div class="table-container">
      <!-- {{ leads }} -->
      <v-data-table
        class="data-table-no-border leads-table"
        v-model="currentPage"
        :headers="headers"
        :items="leads"
        item-value="id"
        :items-per-page="leadStore.items_per_page"
        :hide-default-footer="true"
      >
        <template #[`item.campaignTime`]="{ item }">
          <div
            class="text-center d-flex align-center ga-2"
            style="cursor: pointer"
            @click="goToPreview(item.id, item)"
          >
            <p>{{ item.campaignTime }}</p>
            <p
              v-if="item.new"
              style="
                color: #fff;
                font-size: 12px;
                background-color: #237276;
                padding: 2px 6px;
                border-radius: 6px;
              "
              class="new"
            >
              new
            </p>
          </div>
        </template>

        <template #[`item.marketingCampaign`]="{ item }">
          <div
            class="text-center"
            style="cursor: pointer"
            @click="goToPreview(item.id, item)"
          >
            {{ item.marketingCampaign }}
          </div>
        </template>
        <!-- platform Column -->
        <template #[`item.platform`]="{ item }">
          <div
            class="text-center"
            style="cursor: pointer"
            @click="goToPreview(item.id, item)"
          >
            <img
              v-if="item.platform === 'Snapchat'"
              :src="snapchatIcon"
              :alt="item.platform"
            />
            <img
              v-if="item.platform === 'Twitter'"
              :src="xIcon"
              :alt="item.platform"
            />
            <img
              v-if="item.platform === 'Facebook'"
              :src="facebookIcon"
              :alt="item.platform"
            />
            <img
              v-if="item.platform === 'LinkedIn'"
              :src="LinkedInIcon"
              :alt="item.platform"
            />
            <img
              v-if="item.platform === 'Instagram'"
              :src="instagramIcon"
              :alt="item.platform"
            />
            <img
              v-if="item.platform === 'Tiktok'"
              :src="tiktokIcon"
              :alt="item.platform"
            />
            <p v-if="item.platform === 'Search'">
              {{ item.platform }}
            </p>
            <p v-if="item.platform === 'PR'">
              {{ item.platform }}
            </p>
            <p v-if="item.platform === 'Knocking Door'">
              {{ item.platform }}
            </p>
            <p v-if="item.platform === 'Referral'">
              {{ item.platform }}
            </p>
            <p v-if="item.platform === 'Other'">
              {{ item.platform }}
            </p>
            <p v-if="item.platform === 'Google'">
              <img
                :src="googleIcon"
                style="width: 1.5rem"
                :alt="item.platform"
              />
            </p>
          </div>
        </template>
        <template #[`item.firstName`]="{ item }">
          <div
            class="text-center"
            style="cursor: pointer"
            @click="goToPreview(item.id, item)"
          >
            {{ item.firstName }}
          </div>
        </template>
        <template #[`item.lastName`]="{ item }">
          <div
            class="text-center"
            style="cursor: pointer"
            @click="goToPreview(item.id, item)"
          >
            {{ item.lastName }}
          </div>
        </template>

        <template #[`item.email`]="{ item }">
          <div
            class="text-center"
            style="cursor: pointer"
            @click="goToPreview(item.id, item)"
          >
            <p v-if="item?.ismanual == 0 && item?.email">
              {{ item.email }}
            </p>

            <div v-else-if="item?.emails && item.emails.length > 0">
              <ul class="list-none pa-0 ma-0" style="list-style: none">
                <li v-for="(email, index) in item.emails" :key="index">
                  {{ email?.email }}
                </li>
              </ul>
            </div>

            <p v-else>no email</p>
          </div>
        </template>

        <!-- Phone Number Column -->
        <template #[`item.phoneNumber`]="{ item }">
          <a
            class="phone-link"
            @click="goToPreview(item.id, item)"
            style="cursor: pointer"
            :href="`tel:${item?.phoneNumber}`"
          >
            <img width="24px" :src="phoneIcon" :alt="item?.phoneNumber" />
            <span v-if="item?.ismanual == 0 && item?.phoneNumber">
              {{ item.phoneNumber }}
            </span>

            <div v-else-if="item?.phones && item.phones.length > 0">
              <ul class="pa-0 ma-0" style="list-style: none">
                <li v-for="(phone, index) in item.phones" :key="index">
                  {{ phone?.phone }}
                </li>
              </ul>
            </div>

            <span v-else> no phone </span>
          </a>
        </template>

        <!-- Leads Progress -->
        <template #[`item.leadsProgressCol`]="{ item }">
          <ProgressCol :item="item" />
        </template>

        <!-- Status -->
        <!-- <template #[`item.status`]="{ item }">
          <StatusCol :item="item" />
        </template> -->

        <!-- Comments -->
        <template #[`item.remarks`]="{ item }">
          <CommentCol :item="item" />
        </template>

        <!-- Assignee -->
        <template #[`item.assignee`]="{ item }">
          <div
            class="d-flex align-center ga-2"
            :disabled="loginStore?.user?.role === 'Super Admin'"
          >
            <span v-if="item?.assignee && item.assignee.img">
              <img
                :title="item.assignee?.name || ''"
                class="circle-img cursor-pointer"
                :src="item.assignee.img"
                :alt="item.assignee?.name || 'assignee'"
              />
            </span>

            <v-btn
              v-if="item?.assignee && item.assignee.img"
              :disabled="!hasWritePermission"
              class="dotted-circle-btn"
              icon
              @click="handleClickPermission(item?.id)"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              v-else
              :disabled="!hasWritePermission"
              class="dotted-circle-btn"
              icon
              @click="handleClickPermission2(item?.id)"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
        </template>

        <!-- Conversations -->
        <template #[`item.conversations`]="{ item }">
          <ConversationsCol :item="item" />
        </template>
        <!-- Actions -->
        <template #[`item.actions`]="{ item }">
          <ActionsCol :item="item" />
        </template>
      </v-data-table>
    </div>
  </div>
  <v-dialog v-model="dialog" style="max-width: 41rem" persistent>
    <v-card class="pa-12 rounded-xl">
      <v-card-title class="text-h6 pb-2">Add Agents</v-card-title>
      <v-text-field
        v-model="search"
        prepend-inner-icon="mdi-magnify"
        placeholder="Search for an agent"
        dense
        variant="outlined"
        class="mb-4 add-assi"
        hide-details
      />

      <!-- جروب واحد لراديو -->
      <v-sheet class="agent-list pa-1" elevation="1" rounded>
        <v-radio-group v-model="selectedAgent" hide-details density="compact">
          <v-row
            v-for="agent in filteredAgents"
            :key="agent.id"
            align="center"
            class="pa-2 agent-item"
          >
            <v-col cols="auto">
              <v-radio :value="agent.id" class="ma-0" />
            </v-col>
            <v-col cols="auto">
              <v-avatar size="32">
                <img class="w-100" :src="agent.img" alt="image" />
              </v-avatar>
            </v-col>
            <v-col>
              <span class="agent-name">{{ agent.name }}</span>
            </v-col>
          </v-row>
        </v-radio-group>
      </v-sheet>

      <v-card-actions class="justify-end mt-4">
        <v-btn
          variant="outlined"
          class="px-6 py-2"
          style="
            background-color: #f2f2f2;
            border: none;
            color: #4d4d4d;
            border-radius: 0.6rem;
          "
          @click="dialog = false"
        >
          Cancel
        </v-btn>

        <!-- لو مفيش Assignee -->
        <v-btn
          v-if="!activeLeadHasAssignee"
          variant="outlined"
          class="px-6 py-2"
          style="
            background-color: #3e8387;
            border: none;
            color: #ffffff;
            border-radius: 0.6rem;
          "
          @click="toggleAssignAgent2(selectedAgent)"
          :disabled="!selectedAgent"
        >
          save
        </v-btn>

        <!-- لو فيه Assignee بالفعل -->
        <v-btn
          v-else
          variant="outlined"
          class="px-6 py-2"
          style="
            background-color: #3e8387;
            border: none;
            color: #fff;
            border-radius: 0.6rem;
          "
          @click="saveAssign"
          :disabled="!selectedAgent"
        >
          save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <Pagination :store="leadStore" />
</template>

<script>
import { useLeadsStore } from "@/store/crm/useLeadsStore";
import apiClient from "@/core/buildRequest";

import snapchatIcon from "@/assets/images/icons/snapcaht.svg";
import xIcon from "@/assets/images/icons/x.svg";
import instagramIcon from "@/assets/images/icons/instagram.svg";
import facebookIcon from "@/assets/images/icons/facebook.svg";
import tiktokIcon from "@/assets/images/icons/tiktok.svg";
import phoneIcon from "@/assets/images/icons/phone.svg";
import googleIcon from "@/assets/images/icons/google.svg";
import LinkedInIcon from "@/assets/images/icons/linkedIn.svg";
import ProgressCol from "@/components/crm/leads/ProgressCol.vue";
// import StatusCol from "@/components/crm/leads/StatusCol.vue";
import CommentCol from "@/components/crm/leads/CommentCol.vue";
import Pagination from "@/components/crm/assets/Pagination.vue";
import ActionsCol from "@/components/crm/leads/ActionsCol.vue";
import ConversationsCol from "@/components/crm/leads/ConversationsCol.vue";
import { useGeneralStore } from "@/store/General.js";
import { loginForm } from "@/store/logIn";

export default {
  name: "CustomDataTable",
  components: {
    ProgressCol,
    CommentCol,
    // StatusCol,
    Pagination,
    ActionsCol,
    ConversationsCol,
  },
  data() {
    const leadStore = useLeadsStore();
    return {
      leadStore,
      snapchatIcon,
      xIcon,
      instagramIcon,
      googleIcon,
      facebookIcon,
      tiktokIcon,
      phoneIcon,
      LinkedInIcon,
      dialog: false,
      search: "",
      selected: [],
      agents: [],
      currentLeadId: null,
      generalStore: useGeneralStore(),
      loginStore: loginForm(),
      selectedAgent: null,
      activeItem: null, // ✅ جديد
      activeLeadHasAssignee: false, // ✅ جديد
    };
  },
  computed: {
    filteredAgents() {
      const q = (this.search || "").toLowerCase();
      return this.agents
        .map((a) => ({
          id: a.id,
          name: a.name || a.first_name || a.full_name || "", // ✅ توحيد
          img: a.img || a.image || a.avatar || "/placeholder.png", // ✅ توحيد
        }))
        .filter((a) => a.name.toLowerCase().includes(q));
    },
    hasWritePermission() {
      return this.loginStore?.permissions?.some((p) =>
        [
          "leads-managment.update",
          "leads-managment.create",
          "leads-managment.delete",
        ].includes(p)
      );
    },
    headers() {
      return this.leadStore.headers;
    },
    leads() {
      return this.leadStore.leads;
    },
    currentPage: {
      get() {
        return this.leadStore.current_page;
      },
      set(val) {
        this.leadStore.current_page = val;
        this.leadStore.getAllLeads();
      },
    },
    itemsPerPage: {
      get() {
        return this.leadStore.items_per_page;
      },
      set(val) {
        this.leadStore.items_per_page = val;
        this.leadStore.current_page = 1;
        this.leadStore.getAllLeads();
      },
    },
    totalItems() {
      return this.leadStore.totalItems;
    },
  },
  mounted() {
    this.leadStore.getAllLeads();
    this.fetchAgents();
  },
  methods: {
    handleClickPermission(leadId) {
      if (!this.hasWritePermission) return;
      this.openAssignDialog(leadId);
    },
    handleClickPermission2(leadId) {
      if (!this.hasWritePermission) return;
      this.openAssignDialog(leadId);
    },

    async saveAssign() {
      // ✅ زرار واحد للحفظ
      try {
        if (!this.currentLeadId || !this.selectedAgent) return;

        // لو مفيش أسايني قبل كده → نفس سلوك toggleAssignAgent2
        if (!this.activeLeadHasAssignee) {
          const fd = new FormData();
          fd.append("agent_id", this.selectedAgent);
          await apiClient.post(
            `/leads-managment/assign-agents/${this.currentLeadId}`,
            fd,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
          this.generalStore.showSnackbar("Agent added", "success");
        } else {
          // فيه أسايني بالفعل → استعمل دالتك الحالية
          await this.toggleAssignAgent(this.selectedAgent);
          return; // الدالة دي بالفعل بتقفل الديالوج وتعمل refresh
        }

        await this.leadStore.getAllLeads();
        this.dialog = false;
      } catch (e) {
        this.generalStore.showSnackbar("Operation failed", "error");
      }
    },

    HavePermission(p) {
      return this.loginStore?.permissions?.includes(p) || false;
    },
    updateCurrentPage(val) {
      this.leadStore.currentPage = val;
      this.leadStore.getAllLeads();
    },
    updateItemsPerPage(val) {
      this.leadStore.itemsPerPage = val;
      this.leadStore.currentPage = 1;
      this.leadStore.getAllLeads();
    },
    openAssignDialog(leadId) {
      this.currentLeadId = leadId;
      this.activeItem = this.leads.find((l) => l.id === leadId) || null; // ✅ احتياطي
      this.activeLeadHasAssignee = !!(
        this.activeItem &&
        this.activeItem.assignee &&
        this.activeItem.assignee.img
      );
      this.selectedAgent = null; // ✅ تصفير
      this.search = ""; // ✅ تصفير
      this.dialog = true;
    },
    async fetchAgents() {
      try {
        const response = await apiClient.get("/leads-managment/all-agents");
        this.agents = response.data.data;
      } catch (error) {
        console.error("Error fetching agents:", error);
      }
    },
    async toggleAssignAgent(agentId) {
      if (!this.currentLeadId) return;
      const isChecked = this.selected.includes(agentId);
      try {
        if (!isChecked) {
          const formData = new FormData();
          formData.append("agent_id", agentId);
          await apiClient.post(
            `/leads-managment/assign-agents/${this.currentLeadId}`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
          this.generalStore.showSnackbar("Agent added", "success");
        } else {
          await apiClient.get(
            `/leads-managment/delete/assign-agents/${this.currentLeadId}/agent=${agentId}`
          );
          this.generalStore.showSnackbar("Agent removed", "success");
        }
        await this.leadStore.getAllLeads();
        this.dialog = false;
      } catch (err) {
        this.generalStore.showSnackbar("Operation failed", "error");
      }
    },
    async toggleAssignAgent2(item) {
      try {
        const formData = new FormData();
        formData.append("agent_id", item);
        await apiClient.post(
          `/leads-managment/assign-agents/${this.currentLeadId}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        this.generalStore.showSnackbar("Agent added", "success");
        await this.leadStore.getAllLeads();
        this.dialog = false;
      } catch (err) {
        this.generalStore.showSnackbar("Operation failed", "error");
      }
    },
    goToPreview(id, item) {
      localStorage.setItem("leadId", id);
      // this.$router.push(`/leads/preview/${id}`);
      window.open(`/leads/preview/${id}`, "_blank");
    },
  },
};
</script>

<style>
.table-container .v-table {
  margin: 0px !important;
}
.plus-btn {
  width: 38px;
  height: 38px;
  min-width: 38px !important;
  border-radius: 50%;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  box-shadow: none;
}
.table-container .v-table .v-data-table-footer {
  justify-content: space-between !important;
}
.table-container .v-table .v-table__wrapper table thead {
  background: #edf1f1;
  color: #535862;
}
.table-container .v-table .v-table__wrapper table tbody tr:hover {
  background: #adadad27;
}
.table-container .v-table .v-table__wrapper table tbody tr td {
  padding: 16px 24px 16px 24px;
}

.data-table-no-border
  .v-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td,
.data-table-no-border
  .v-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th {
  border: none !important;
}
.data-table-no-border > .v-table__wrapper > table > tbody > tr > th,
.data-table-no-border > .v-table__wrapper > table > thead > tr > th,
.data-table-no-border > .v-table__wrapper > table > tfoot > tr > th {
  border: none !important;
}
</style>

<style scoped>
.table-wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: white;
  border-radius: 8px;
}

.table-container {
  width: 100%;
  position: relative;
  overflow-x: auto;
}

.v-data-table {
  width: 100%;
  margin: 1rem 0;
}

:deep(.v-data-table__wrapper) {
  overflow-x: auto;
  width: 100%;
}

:deep(.v-data-table > .v-data-table__wrapper > table) {
  width: 100%;
  white-space: nowrap;
}

:deep(.v-data-table th) {
  white-space: nowrap;
  min-width: 120px;
}

:deep(.v-pagination__item--is-active) {
  background-color: #237276 !important;
  color: #ffffff !important;
  font-weight: bold;
  border-radius: 4px;
}

.phone-link {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666666;
  text-decoration: none;
}

.phone-link:hover {
  text-decoration: underline;
}

:deep(.v-data-table) {
  text-transform: capitalize;
}
.dotted-circle-btn {
  width: 1.4rem !important;
  height: 1.4rem !important;
  border: 2px dashed #bbb;
  border-radius: 50%;
  background-color: transparent;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  box-shadow: none !important;
}
.dotted-circle-btn:hover {
  color: #117e3e;
}
.agent-list {
  max-height: 250px;
  overflow-y: scroll;
  box-shadow: none !important;
}

.agent-item {
  border-radius: 8px;
  transition: background-color 0.2s;
  background-color: #fafafa;
  margin: 8px 0;
}

.agent-item:hover {
  background-color: #eeeeee;
  cursor: pointer;
}

.agent-name {
  color: #0a7b6c;
  font-weight: 500;
}
:deep(.v-overlay__scrim) {
  background-color: rgba(0, 0, 0, 0.05) !important;
}
:deep(.v-overlay__content > .v-card) {
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.04) !important;
}
.add-assi input {
  padding: 0 !important;
}
</style>
